import React, { useEffect, useState } from 'react';
import Breadcrumb from '../components/ui/Breadcrumb';
import { Checkbox } from '../components/ui/Checkbox';
import Button from '../components/ui/Button';
import Input from '../components/ui/Input';
import api from '../utils/api';

const Settings = () => {
  const [settings, setSettings] = useState(() => ({
    notifications: true,
    weeklySummary: true,
    darkMode: localStorage.getItem('darkMode') === 'true',
    scheduleTracker: 'weekly'
  }));
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const savedDarkMode = localStorage.getItem('darkMode');
    (async () => {
      try {
        const { data } = await api.get('/settings');
        setSettings(prev => ({
          ...prev,
          ...data,
          darkMode: savedDarkMode === null ? Boolean(data?.darkMode) : savedDarkMode === 'true'
        }));
      } catch {
        // keep defaults
      }
    })();
  }, []);

  useEffect(() => {
    if (settings.darkMode) document.documentElement.classList.add('dark');
    else document.documentElement.classList.remove('dark');
    localStorage.setItem('darkMode', String(settings.darkMode));
  }, [settings.darkMode]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const { data } = await api.put('/settings', settings);
      setSettings(prev => ({ ...prev, ...data }));
    } finally { setSaving(false); }
  };

  return (
    <div className="w-full px-3 sm:px-4 lg:px-6 py-4 sm:py-6 lg:py-8">
      <Breadcrumb />
          <h1 className="text-2xl sm:text-3xl font-semibold text-foreground mb-4">Settings</h1>
          <div className="bg-card border border-border rounded-lg p-4 sm:p-6 space-y-4">
            <Checkbox label="Enable notifications" checked={settings.notifications} onChange={(e) => setSettings(s => ({ ...s, notifications: e.target.checked }))} />
            <Checkbox label="Send weekly summary email" checked={settings.weeklySummary} onChange={(e) => setSettings(s => ({ ...s, weeklySummary: e.target.checked }))} />
            <Checkbox label="Enable dark mode" checked={settings.darkMode} onChange={(e) => setSettings(s => ({ ...s, darkMode: e.target.checked }))} />
            <Input label="Schedule tracker (daily/weekly/monthly)" value={settings.scheduleTracker} onChange={(e) => setSettings(s => ({ ...s, scheduleTracker: e.target.value }))} />
            <div className="pt-2">
              <Button variant="default" onClick={handleSave} loading={saving} disabled={saving}>
                Save Settings
              </Button>
            </div>
          </div>
        </div>
  );
};

export default Settings;
